import { useState, useCallback } from "react"

import styled from "styled-components"

import type { IPart } from "~/containers/Proposal/Setup/Form/setup-steps-types"
import { useDesignContext } from "~/containers/Proposal/state/designs/design-context"
import { useProposalContext } from "~/containers/Proposal/state/proposal/proposal-context"
import { fontWeight } from "~/utils/styles"

import SystemPricing from "./SystemPricing"
import { SetupMenuFormFooter } from "../../SetupMenuFooter"

const Container = styled.div`
  padding: 20px 40px;
  position: relative;
  overflow: hidden;
  max-height: calc(100vh - 200px);
  overflow-y: auto;

  .no-adders {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 18px;
    border: 1px solid var(--grey-border);
    border-radius: 4px;
    width: 775px;
    height: 300px;
    margin: 20px 0;
    p {
      font-size: 13px;
      line-height: 16px;
      ${fontWeight(600)}
      color: #C0C1C7
    }
  }
`

export const AddersOverview: IPart[`form`] = () => {
  const proposal = useProposalContext()
  const design = useDesignContext()
  const [isLoadingPricePerWatt, setIsLoadingPricePerWatt] = useState(false)
  const [isMarginValid, setIsMarginValid] = useState(true)

  const handlePricePerWattUpdate = useCallback(
    (isLoading: boolean, isValid: boolean) => {
      setIsLoadingPricePerWatt(isLoading)
      setIsMarginValid(isValid)
    },
    [],
  )

  return (
    <form
      style={{ display: `flex`, flexDirection: `column` }}
      onSubmit={(e) => e.preventDefault()}
    >
      <Container>
        <SystemPricing />
      </Container>
      <SetupMenuFormFooter
        entitiesToUpdate={[proposal]}
        isLoading={proposal.isSaving || design.isSaving}
        isDisabled={!isMarginValid || isLoadingPricePerWatt}
      />
    </form>
  )
}
